var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blogPostId)?_c('blog-editor',{attrs:{"post-id":_vm.blogPostId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }